import { BaseDTO } from '@/request/apiConfig';
import { TicketDTO } from '@/mixin/wecomJSSDK';
import myAxios from '@/request/myAxios';

const AUTH_CONTEXT_PATH = import.meta.env.VITE_AUTH_CONTEXT_PATH;

export const apiWecomJSSDK = {
  configSignature: (url: string): Promise<BaseDTO<TicketDTO>> =>
    myAxios.post(`${AUTH_CONTEXT_PATH}/wecom/jssdk/config`, { url }),
  agentConfigSignature: (url: string): Promise<BaseDTO<TicketDTO>> =>
    myAxios.post(`${AUTH_CONTEXT_PATH}/wecom/jssdk/agent`, { url }),
};
